// extracted by mini-css-extract-plugin
module.exports = {"icon":"ActivityAction_icon__3gD3V","action":"ActivityAction_action__jMieD"};